import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import ProgressBar from './ProgressBar';
import Logo from './Logo';

export interface FormStepLayoutProps {
  title: string;
  children: ReactNode;
  currentStep: number;
  totalSteps?: number;
  nextLabel?: string;
  onNext?: () => void;
  showNext?: boolean;
  submitButton?: boolean;
  nextDisabled?: boolean;
  /** When true, only the card is rendered (no outer .form-step-page). Use when wrapping the page shell yourself. */
  omitPageShell?: boolean;
}

const FormStepLayout = ({
  title,
  children,
  currentStep,
  totalSteps = 3,
  nextLabel,
  onNext,
  showNext = true,
  submitButton = false,
  nextDisabled = false,
  omitPageShell = false,
}: FormStepLayoutProps): JSX.Element => {
  const { t } = useTranslation();
  const resolvedNext = nextLabel ?? t('forms.next');

  const card = (
    <div className="form-step-card">
      <header className="form-step-card-header">
        <Logo />
        <p className="form-step-secure-label">{t('forms.secureLabel')}</p>
      </header>
      <h1 className="form-step-title">{title}</h1>
      <div className="form-step-body">{children}</div>
      <footer className="form-step-footer">
        {showNext && (
          <button
            type={submitButton ? 'submit' : 'button'}
            className="btn-next"
            onClick={!submitButton ? onNext : undefined}
            disabled={nextDisabled}
          >
            {resolvedNext}
          </button>
        )}
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
      </footer>
    </div>
  );

  if (omitPageShell) {
    return card;
  }

  return <div className="form-step-page">{card}</div>;
};

export default FormStepLayout;
